import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const CommandGuideModal = ({ isOpen, onClose, userLevel }) => {
  const [position, setPosition] = useState({ x: 450, y: 150 });
  const [isDragging, setIsDragging] = useState(false);
  const offset = useRef({ x: 0, y: 0 });

  if (!isOpen) return null;

  const allCommands = [
    { cmd: "/tip NAME", desc: "Send a cash tip to another player (24h cooldown)." },
    { cmd: "/donate AMOUNT", desc: "Contribute funds to the mint multiplier pool." },
    { cmd: "/pip predict TICKER DAYS", desc: "Get intelligent price predictions for this company in x days." },
    { cmd: "/pip quote TICKER", desc: "Fetch the latest market quote for a ticker." },
    { cmd: "/pip news TICKER", desc: "See recent news affecting the current stock." },
    { cmd: "/pip holders TICKER", desc: "List top shareholders for this company." },
    { cmd: "/pip pick", desc: "Get PIP's top stock pick." },
    { cmd: "/pip value", desc: "Get an official portfolio appraisal from PIP." },
    { cmd: "/pip report", desc: "Generate a market analysis report." },
  ];

  const visibleCommands = userLevel === "Basic" 
    ? allCommands.filter(c => !c.cmd.startsWith("/pip")) 
    : allCommands;

  const handleMouseDown = (e) => {
    setIsDragging(true);
    offset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - offset.current.x,
      y: e.clientY - offset.current.y
    });
  };

  const handleMouseUp = () => setIsDragging(false);

  return createPortal(
    <div 
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      style={{
        position: "fixed",
        left: position.x,
        top: position.y,
        width: "350px",
        background: "#0f1515",
        border: "1px solid #50e3c2",
        boxShadow: "0 0 20px rgba(0,0,0,0.8)",
        zIndex: 100000,
        userSelect: isDragging ? "none" : "auto",
        fontFamily: "monospace"
      }}
    >
      <div 
        onMouseDown={handleMouseDown}
        style={{ 
          padding: "10px 15px", 
          background: "rgba(80, 227, 194, 0.15)", 
          borderBottom: "1px solid rgba(80, 227, 194, 0.3)",
          cursor: "grab",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#50e3c2",
          fontSize: "0.75rem",
          fontWeight: "bold"
        }}
      >
        <span>COMMAND REFERENCE {userLevel === "Basic" ? "(BASIC)" : "(PREFERRED+)"}</span>
        <button 
          onClick={onClose}
          style={{ background: "transparent", border: "none", color: "#50e3c2", cursor: "pointer", fontSize: "1rem" }}
        >
          ✕
        </button>
      </div>

      <div style={{ padding: "15px", maxHeight: "400px", overflowY: "auto" }}>
        {visibleCommands.map((item, idx) => (
          <div key={idx} style={{ marginBottom: "12px" }}>
            <div style={{ color: "#ffd700", fontSize: "0.85rem", fontWeight: "bold" }}>
              {item.cmd}
            </div>
            <div style={{ color: "#aaa", fontSize: "0.75rem", marginTop: "2px", lineHeight: "1.4" }}>
              {item.desc}
            </div>
          </div>
        ))}
        
        {userLevel === "Basic" && (
          <div style={{ color: "#555", fontSize: "0.7rem", marginTop: "10px", borderTop: "1px solid #222", paddingTop: "10px" }}>
            Upgrade level to unlock PIP commands.
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default CommandGuideModal;